import { render } from "./payer-select.vue?vue&type=template&id=7a7bbe3b&scoped=true"
import script from "./payer-select.vue?vue&type=script&lang=js"
export * from "./payer-select.vue?vue&type=script&lang=js"

import "./payer-select.vue?vue&type=style&index=0&id=7a7bbe3b&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a7bbe3b"]])

export default __exports__